import { useAppDispatch } from 'store/hooks'
import { getSelectedCompanyId } from 'utils/company'
import { useFilterStoreData } from 'utils/hooks/useFilterStoreData'
import { useRetailDashboardPageSettingsQuery } from 'api/hooks'
import { preparePageName } from 'components/Common/PresetModal/_methods'
import {
  setCurrency,
  setMerchant1,
  setMerchant2,
} from 'store/retail-price-report'
import { useCheckMobile } from 'utils/hooks/useMediaQuery'

export const defaultCurrencyValue = {
  id: 1,
  code: 'EUR',
  symbol: '€',
}
export const useGetPageSettings = () => {
  const { storeName } = useFilterStoreData()
  const dispatch = useAppDispatch()

  useRetailDashboardPageSettingsQuery({
    variables: {
      page: preparePageName(storeName),
      companyId: getSelectedCompanyId(),
    },
    onCompleted: data => {
      const pageSettings =
        data?.me?.company?.pageSettings ?? data?.me?.pageSettings
      const currency = pageSettings?.currency ?? null
      const merchant1 = pageSettings?.merchant1 ?? null
      const merchant2 = pageSettings?.merchant2 ?? null

      dispatch(setCurrency(currency))
      dispatch(setMerchant1(merchant1))
      dispatch(setMerchant2(merchant2))
    },
  })
}
export const useGetBackgroundForScreen = ({
  backgroundUrlS,
  backgroundUrlXL,
}) => {
  const isMobile = useCheckMobile()
  return isMobile ? backgroundUrlS : backgroundUrlXL
}
